export default {
  info: {
    id: 'merchant_options_shipping_shipping_advice',
    defaultMessage:
      'You need at least one free delivery option for each category in order for your listing to be online.',
  },
} as const
